export const setAlertMessage = (msg) => ({
    type: 'SET_ALERT_MESSAGE',
    payload: msg
});
export const showAlert = () => ({
    type: 'SHOW_ALERT'
});
export const hideAlert = () => ({
    type: 'HIDE_ALERT'
});
export const setAlertTypePrimary = () => ({
    type: 'SET_ALERT_TYPE_PRIMARY'
});
export const setAlertTypeDanger = () => ({
    type: 'SET_ALERT_TYPE_DANGER'
});